import { createFileRoute } from "@tanstack/react-router";
import { BetaEntry } from "@/features/beta/beta-entry";
export const Route = createFileRoute("/b")({ component: BetaEntry });
